import React from 'react';
import { CTAButton } from './CTAButton';
import { modules } from '../data/modules';
export function ModulesSection() {
  return <section className="bg-ivory-deep px-4 sm:px-6 py-9 sm:py-12" data-id="element-135" data-mp="1ntwbsbwstd7s">
      <div className="max-w-4xl mx-auto" data-id="element-136" data-mp="1iv1pgzzmh6ix">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-2" data-id="element-137" data-mp="1ivurjnnmz7uq">
          The complete <span className="text-green-dark" data-id="element-138" data-mp="2bks5xfoq8ki7">6-module</span> system
        </h2>
        <p className="text-[12px] sm:text-sm text-petrol/65 leading-snug text-center max-w-xl mx-auto mb-6" data-id="element-139" data-mp="26l5tv9kmxaaz">
          Six professional resources designed to work together — from individual
          movements to complete classes, structured training and long-term
          programming.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5 mb-6" data-id="element-140" data-mp="q6w3k9wu1bhi">
          {modules.map(module => <article key={module.number} className="bg-white border border-petrol/10 rounded-lg p-4 flex flex-col shadow-sm" data-id="element-141" data-mp="l7b849gvfl9j">
              <p className="font-heading font-bold text-[9px] sm:text-[10px] uppercase tracking-[0.16em] text-green-dark mb-1.5" data-id="element-142" data-mp="1ite5qio280zv">
                Module {module.number}
              </p>

              <h3 className="font-heading font-extrabold uppercase text-sm sm:text-base leading-tight tracking-tight text-petrol mb-1.5" data-id="element-143" data-mp="18wswfl50c3q8">
                {module.title}
              </h3>

              <p className="font-heading font-semibold uppercase text-[10px] sm:text-[11px] tracking-wide text-petrol/90 leading-snug mb-2" data-id="element-144" data-mp="10364k63x7kmb">
                {module.hook}
              </p>

              <p className="text-[12px] sm:text-sm text-petrol/70 leading-relaxed mb-3" data-id="element-145" data-mp="q84ijj4xyyny">
                {module.description}
              </p>

              <ul className="flex flex-wrap gap-1 pt-2.5 border-t border-petrol/10 mb-2.5" data-id="element-146" data-mp="h5v6gou0yx8g">
                {module.tags.map(tag => <li key={tag} className="rounded bg-ivory border border-petrol/10 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-petrol/65" data-id="element-147" data-mp="l6f5xz22mcxr">
                    {tag}
                  </li>)}
              </ul>

              <p className="mt-auto text-[11px] sm:text-xs font-semibold text-green-dark leading-snug" data-id="element-148" data-mp="2e53yqqvybzqc">
                {module.closer}
              </p>
            </article>)}
        </div>

        <div className="max-w-xs sm:max-w-sm mx-auto" data-id="element-149" data-mp="36rolfe1hfnnk">
          <CTAButton data-id="element-150" data-mp="31u6e1s345gho">Get all 6 modules now</CTAButton>
        </div>
      </div>
    </section>;
}